import { Skeleton, Tooltip } from '@heroui/react';
import { truncate } from 'lodash';

import { CopyableText } from '~/components/CopyableText';
import { useTruncatedTooltip } from '~/components/TruncatedText';

type LogMessageCellProps = {
  logMessage: string;
};

export function LogMessageCell({ logMessage }: LogMessageCellProps) {
  const { ref, isTruncated, tooltipWidth } = useTruncatedTooltip(logMessage);

  if (!logMessage) return null;

  return (
    <CopyableText
      text={logMessage}
      className='whitespace-normal text-left'
      data-testid='monitor-pipeline-logs-cell-message'
    >
      <Tooltip
        isDisabled={!isTruncated}
        content={
          <span
            style={{
              maxWidth: tooltipWidth,
              display: 'block',
              wordBreak: 'break-all'
            }}
          >
            {truncate(logMessage, { length: 1000 })}
          </span>
        }
      >
        <p
          ref={ref as React.RefObject<HTMLParagraphElement>}
          className='line-clamp-1 break-all'
        >
          {logMessage}
        </p>
      </Tooltip>
    </CopyableText>
  );
}

export function LogMessageCellSkeleton() {
  return <Skeleton className='h-5 w-[300px] rounded' />;
}
